import { z } from 'zod';

/** Provider-agnostic delivery events (mapped from Resend webhooks by the API layer). */
export const EmailProviderEventType = {
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  BOUNCED: 'BOUNCED',
  COMPLAINED: 'COMPLAINED',
} as const;
export type EmailProviderEventType =
  (typeof EmailProviderEventType)[keyof typeof EmailProviderEventType];
export const EmailProviderEventTypeSchema = z.enum(EmailProviderEventType);

export const EmailProviderEventSchema = z
  .object({
    /** Webhook delivery ID (svix-id) – used for idempotency. */
    eventId: z.string().min(1),
    type: EmailProviderEventTypeSchema,
    /** Provider message ID (Resend `email_id`). */
    providerMessageId: z.string().min(1),
    occurredAt: z.iso.datetime({ offset: true }),
    /** Hard bounce (`Permanent`) vs soft; only hard bounces mark the registration BOUNCED. */
    permanent: z.boolean(),
  })
  .strict();
export type EmailProviderEvent = z.infer<typeof EmailProviderEventSchema>;
